// Mixins 
import { AppsData } from '../../mixins/apps-data.js';
//Scss
import './footer.scss';
// Template and media files
import template from './footer.vhtml';
import footerLogo from '../../../_img/logo.svg';
import linkedinIcon from '../../../_img/icons/icon-linkedin.svg';
import instagramIcon from '../../../_img/icons/icon-instagram.svg';
import fbIcon from '../../../_img/icons/icon-facebook.svg';
import arrow from '../../../_img/icons/arrow-down.svg';

export default {
	template: template,
	components: {
		footerLogo,
		linkedinIcon,
		instagramIcon,
		arrow,
		fbIcon,
	},
	mixins: [
		AppsData,
	],
	props: {
	},
	data: () => ({

	}),
};



// WEBPACK FOOTER //
// ./assets/_js/components/footer/footer.js